import { Avatar, Button, Flex, Space } from "antd";
import type { ReactNode } from "react";
import { Link } from "react-router";
import EditIcon from "../../../assets/icons/EditIcon";
import IMAGES from "../../../assets/images";
import useAuth from "../../../hooks/useAuth";
import { cn } from "../../../utils/global.utils";
import { isActivePath } from "../../../utils/string.utils";
import LogoutIcon from "../_icons/LogoutIcon";
import { sidebarItems } from "../constants";

type Props = {
  children: ReactNode;
};

export default function UserSidebar({ children }: Props) {
  const { logout, employee } = useAuth();

  return (
    <section className="container pt-10 pb-16">
      <Flex gap={20}>
        <aside className="w-80 sticky top-28 self-start hidden xl:block">
          <div className="bg-white rounded-xl border border-theme-zinc-200">
            <Flex align="center" gap={16} className="p-4">
              <div className="w-12">
                <Avatar
                  src={employee?.profilePhotoUrl || IMAGES.avatar}
                  size={48}
                  className="rounded-full"
                />
              </div>
              <div className="flex-1">
                <h6 className="text-theme-zinc-700 text-base font-medium break-all">
                  {employee?.fullName || employee?.email || "Unknown User"}
                </h6>
                <p className="text-theme-slate-500 text-base font-normal">
                  {employee?.phone || "Unknown Phone"}
                </p>
              </div>
              <Link to="/user/profile/update?type=general" className="ml-auto">
                <Button
                  className="!text-theme-slate-300"
                  type="text"
                  size="small"
                  icon={<EditIcon className="relative top-0.5" />}
                />
              </Link>
            </Flex>

            <div className="pt-3 pb-2.5 border-y border-theme-zinc-200">
              <Space direction="vertical" size={0} style={{ width: "100%" }}>
                {sidebarItems.map((el) => {
                  const isActive = isActivePath(1, el.path);

                  return <LinkItem {...el} isActive={isActive} key={el.path} />;
                })}
              </Space>
            </div>

            <div className="py-2.5">
              {/* <LinkItem
                path="setting"
                label="সেটিংস"
                isActive={isActivePath(1, "setting")}
                icon={SettingIcon}
              /> */}
              <button
                className="flex items-center w-full px-4"
                onClick={logout}
              >
                <span className="relative -top-0.5 text-theme-red-500 w-[22px] inline-flex justify-center">
                  <LogoutIcon />
                </span>
                <span className="text-base font-normal justify-start px-4 py-2 space-x-2 text-theme-red-500">
                  লগ আউট
                </span>
              </button>
            </div>
          </div>
        </aside>

        <div className="flex-1">{children}</div>
      </Flex>
    </section>
  );
}

type TLinkItem = {
  path: string;
  label: string;
  icon: React.ComponentType<any>;
  isActive: boolean;
};

const LinkItem = ({ path, icon: Icon, label, isActive }: TLinkItem) => (
  <Link
    className="flex items-center px-4 transition-colors hover:bg-theme-slate-50"
    to={`/user/${path}`}
  >
    <span
      className={cn(
        "relative -top-0.5 text-theme-slate-300",
        isActive && "text-theme-primary",
      )}
    >
      <Icon />
    </span>
    <span
      className={cn(
        "text-base font-normal justify-start px-4 py-2 space-x-2 text-theme-zinc-700",
        isActive && "text-theme-primary font-medium",
      )}
    >
      {label}
    </span>
  </Link>
);
